<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="reject_comment" />
        <v-card>
          <v-form class="pa-6" ref="form">
            <NewPublication
              :publication="publication"
              :mod-op_id="modOp_id"
              :disabled-form="disabledForm"
              teseo_link
              @change-files="emitChangeFiles"
              @save-form="saveform_trigger = !saveform_trigger"
            />
            <v-row>
              <v-col cols="12">
                <h3 class="mt-15 mb-0">
                  {{ $t("title.thesisData") }}
                </h3>
              </v-col>
            </v-row>

            <h5>
              {{ $t("form.thesis.doctoral_program") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-combobox
                  v-model="publication.thesis.doctoral_program"
                  :label="$t('form.thesis.doctoral_program')"
                  :items="doctoralPrograms"
                  required
                  outlined
                  :rules="rules.char_max_150"
                  :readonly="disabledForm"
                  :counter="150"
                ></v-combobox>
              </v-col>
            </v-row>
            <h5>
              {{ $t("label.dates") }}
            </h5>
            <v-row>
              <v-col cols="12" sm="6" class="py-0">
                <v-menu
                  v-model="menu_start_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.thesis.start_date"
                      :label="$t('form.thesis.start_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.thesis.start_date"
                    @input="menu_start_date = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <v-menu
                  v-model="menu_deposit_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.thesis.deposit_date"
                      :label="$t('form.thesis.deposit_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.thesis.deposit_date"
                    @input="menu_deposit_date = false"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.thesis.thesisLecture") }}
            </h5>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field
                  v-model="publication.thesis.read_center"
                  :label="$t('form.thesis.read_center')"
                  required
                  outlined
                  :rules="rules.char_max_100"
                  :readonly="disabledForm"
                  :counter="100"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-menu
                  v-model="menu_lecture_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.thesis.lecture_date"
                      :label="$t('form.thesis.lecture_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.thesis.lecture_date"
                    @input="menu_lecture_date = false"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-combobox
                  v-model="publication.thesis.grade"
                  :label="$t('form.thesis.grade')"
                  :items="gradeOptions"
                  required
                  outlined
                  :rules="rules.char_max_40"
                  :readonly="disabledForm"
                  :counter="40"
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <h5>
                  {{ $t("form.thesis.international_phd") }}
                </h5>
                <v-checkbox
                  class="big"
                  v-model="publication.thesis.international_phd"
                  :label="$t('form.thesis.internationalPhdDetail')"
                  :readonly="disabledForm"
                />
              </v-col>
            </v-row>
            <h5>{{ $t("form.thesis.directors") }}</h5>
            <SelectPeopleComboBox
              :disabled-form="disabledForm"
              :items-selected="publication.thesis.directors"
            />
            <h5>{{ $t("form.thesis.tutor") }}</h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-combobox
                  v-model="tutorSelected"
                  :items="namePersons"
                  item-value="id"
                  item-text="name"
                  :readonly="disabledForm"
                  clearable
                ></v-combobox>
              </v-col>
            </v-row>
            <v-divider />
            <UserFormActions
              form_name_text="new thesis"
              :form_name="form_name"
              :refForm="$refs.form"
              :object_type="object_type"
              :data="processData"
              :state="state"
              :saveform_trigger="saveform_trigger"
              @change-state="changeState"
              :paginated-form="true"
              class="text-center mt-6"
            />
          </v-form>
        </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import NewPublication from "./NewPublication";
import SelectPeopleComboBox from "../../reusables/SelectPeopleComboBox";
import publication_model from "../../../mixins/model_utils/publication_model";
import publication_data from "../../../mixins/publication_data";

export default {
  mixins: [changeState, validationRules, publication_data, publication_model],
  components: {
    SelectPeopleComboBox,
    NewPublication,
    RejectCommentLayout,
    UserFormActions,
  },

  data: () => ({
    form_name: "newThesisForm",
    menu: false,
    saveform_trigger: false,
    state: "",
    reject_comment: "",
    object_id: null,
    object_type: "publication",
    menu_start_date: false,
    menu_deposit_date: false,
    menu_lecture_date: false,
    tutorSelected: null,
    modOp_id: null,
  }),

  created() {
    this.getNamePersons();
    this.getGradeOptions();
    this.getDoctoralProgramOptions();
    if (this.updatePublication || this.updatePublicationForm) {
      this.getPublication();
    } else {
      if (this.$store.getters.user !== null) {
        this.loadDefaultAuthor();
      }
    }
  },

  computed: {
    updatePublicationForm() {
      return this.$route.params.id > -1 && !this.updatePublication;
    },
    updatePublication() {
      return this.$route.params.id > -1 && this.$route.meta.update;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      let tutor = null;
      if (this.tutorSelected !== null && this.tutorSelected !== undefined) {
        if (typeof this.tutorSelected == "string") {
          tutor = {
            id: null,
            name: this.tutorSelected
          };
        } else if (this.tutorSelected.id != null) {
          tutor = this.tutorSelected.id;
        } else {
          tutor = this.tutorSelected;
        }
      }
      let data = {
        title: this.publication.title,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.object_id,
        data: {
          user: {
            publication: {
              title: this.publication.title,
              abstract: this.publication.abstract,
              acknowledgements: this.publication.acknowledgements,
              keywords: this.publication.keywords,
              doi: this.publication.doi,
              isbn: this.publication.isbn,
              authors_text: this.publication.authors_text,
              authorsrel: this.publication.authorsrel,
              research_areas: this.publication.research_areas.filter(area => Number.isInteger(area)),
              num_authors: this.publication.num_authors,
              links: this.publication.links,
              is_external: this.publication.is_external,
              hidden: this.publication.hidden,
              featured: this.publication.featured,
              language: this.publication.language,
              minerva_sync_option: this.publication.minerva_sync_option,
              regional: this.publication.regional,
              national: this.publication.national,
              international: this.publication.international,
              files: this.files,
              thesis: {
                doctoral_program: this.publication.thesis.doctoralPrograms,
                start_date: this.publication.thesis.start_date,
                deposit_date: this.publication.thesis.deposit_date,
                lecture_date: this.publication.thesis.lecture_date === "" ? null : this.publication.thesis.lecture_date,
                read_center: this.publication.thesis.read_date,
                grade: this.publication.thesis.grade,
                international_phd: this.publication.thesis.international_phd,
                tutor: tutor,
                directors: this.publication.thesis.directors,
              }
            }
          }
        }
      };
      return data;
    }
  },

  methods: {
    loadTutorSelected(item) {
      if (typeof item == "number") {
        this.tutorSelected = this.namePersons.filter(
          tutor => tutor.id === item
        )[0];
      } else {
        this.tutorSelected = item;
      }
    },
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.normalizePublicationDefaults(this.publication);
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.loadTutorSelected(this.publication.thesis.tutor);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
